import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file-list-video",
  "use": "icon-file-list-video-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-file-list-video\"><defs><style type=\"text/css\"></style></defs><path d=\"M917 105.2h-34V173H781.3v-67.8H238.7V173H136.9v-67.8H103c-18.7 0-33.9 15.2-33.9 33.9v746.1c0 18.7 15.2 33.9 33.9 33.9h33.9v-33.9h101.7v33.9h542.6v-33.9H883v33.9h34c18.7 0 33.9-15.2 33.9-33.9V139.1c0-18.6-15.3-33.9-33.9-33.9zM238.7 783.5H136.9V681.8h101.7v101.7z m0-203.5H136.9V478.3h101.7V580z m0-203.5H136.9V274.8h101.7v101.7z m426.9 158L445 663.1c-3.6 1.8-7.5 2.6-11.4 2.6-4.7 0-9.2-1.3-13.4-3.7-7.5-4.5-12-12.6-12-21.2V383.6c0-8.6 4.5-16.7 12-21.2s16.9-4.9 24.8-1L665.5 490c8.6 4.2 14 12.8 14 22.2 0.1 9.4-5.4 18-13.9 22.3z m217.4 249H781.3V681.8H883v101.7z m0-203.5H781.3V478.3H883V580z m0-203.5H781.3V274.8H883v101.7z m0 0\" p-id=\"27523\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file-list-video.svg
// module id = r8iq
// module chunks = 22